// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/messaging";
import "firebase/compat/database";

import { enableIndexedDbPersistence } from "firebase/firestore";
import { GoogleAuthProvider } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC2vhNpYoas6NBBoTa8Ac3tPu_H2vQKE_I",
  authDomain: "schooldiary-1339b.firebaseapp.com",
  projectId: "schooldiary-1339b",
  storageBucket: "schooldiary-1339b.appspot.com",
  messagingSenderId: "987817055798",
  appId: "1:987817055798:web:9949df609c3820ce9eea97",
  measurementId: "G-9FWD4SQG61",
  storageBucket: "gs://schooldiary-1339b.appspot.com",
  databaseURL: "https://schooldiary-1339b-default-rtdb.europe-west1.firebasedatabase.app/",
};

// Initialize Firebase
let app, analytics;
try {
    app = firebase.default.app()
} catch (err) {
    app = firebase.default.initializeApp(firebaseConfig);
}

if (JSON.parse(localStorage.getItem("cookies"))?.statisticCookies)
    analytics = firebase.analytics();

const db = firebase.firestore();  
const auth = firebase.auth();
const storage = firebase.storage();
const messaging = firebase.messaging();
const realtimeDb = firebase.database();

auth.languageCode = 'it';

enableIndexedDbPersistence(db)
  .then(() => console.log("persistence enabled"))
  .catch(err => {
    if (err.code == "failed-precondition") {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      console.log("Multiple tabs open, persistence can only be enabled in one tab at a time.");
    } else if (err.code == "unimplemented") {
      // The current browser does not support all of the
      // features required to enable persistence
      console.log("The current browser does not support all of the features required to enable persistence.");
    }
});



const googleAuthProvider = new GoogleAuthProvider();
// googleAuthProvider.addScope('https://www.googleapis.com/auth/classroom.courses.readonly');
// googleAuthProvider.addScope('https://www.googleapis.com/auth/classroom.coursework.me');

export {

  app,
  analytics,
  db,
  realtimeDb,
  auth, 
  storage,
  messaging,
  googleAuthProvider,

};